// Guard dùng chung cho lệnh MUTATE của avatar (sync...). Đảm bảo cwd nằm trong
// Avatar workspace (marker .claude/avatar.json). Nếu không: khi phát hiện đây là
// workspace của CLI kia (avatar-po) → báo lỗi hướng dẫn dùng đúng `avatar-po` thay
// vì xui `avatar init` (tránh init đè lên workspace avatar-po).
//
// Trả workspaceRoot nếu hợp lệ; process.exit(1) với hint nếu không.
import {
  detectForeignWorkspaceFromCwd,
  resolveAvatarWorkspaceRootFromCwd,
} from "./resolve-avatar-workspace-root-from-cwd.js";
import { log } from "./terminal-logger.js";
import { FOREIGN_CLI_NAME } from "./workspace-marker-constants.js";

export function assertInAvatarWorkspaceOrExit(cwd: string = process.cwd()): string {
  const workspaceRoot = resolveAvatarWorkspaceRootFromCwd(cwd);
  if (workspaceRoot) {
    if (workspaceRoot !== cwd) log.dim(`Detected workspace root: ${workspaceRoot}`);
    return workspaceRoot;
  }

  // Đứng nhầm nhà avatar-po → gợi ý CLI đúng.
  if (detectForeignWorkspaceFromCwd(cwd) === FOREIGN_CLI_NAME) {
    log.error(
      `Thư mục này là workspace của '${FOREIGN_CLI_NAME}' (không phải avatar).\n` +
        `  Dùng lệnh '${FOREIGN_CLI_NAME}' tương ứng, hoặc cd sang Avatar workspace.`,
    );
    process.exit(1);
  }

  log.error(
    "Không phải Avatar workspace (thiếu .claude/avatar.json).\n" +
      "  Chạy 'avatar init' để khởi tạo.",
  );
  process.exit(1);
}
